export enum ProgressStatus {
  STARTING = 'STARTING',
  PROGRESS = 'PROGRESS',
  FAILED = 'FAILED',
  SUCCEED = 'SUCCEED'
}

export const progressStatusDescriptions = {
  [ProgressStatus.STARTING]: 'Iniciando',
  [ProgressStatus.PROGRESS]: 'Progresso',
  [ProgressStatus.FAILED]: 'Falhou',
  [ProgressStatus.SUCCEED]: 'Concluído'
};

export const progressStatusIcons = {
  [ProgressStatus.STARTING]: 'fa fa-spinner fa-pulse',
  [ProgressStatus.PROGRESS]: 'fa fa-spinner fa-pulse',
  [ProgressStatus.FAILED]: 'fa fa-times-circle',
  [ProgressStatus.SUCCEED]: 'fa fa-check-circle'
};
